/* istanbul ignore file */
/**
 * Created by sswaminathan on 2/1/22
 * File: ScreenLoader.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { LoadingIcon } from '@panwds/react-ui'
import { useMemo } from 'react'

const ScreenLoader = ({ appearance = 'dark' }) => {

  const classNames = useMemo(() => {
    const classNames = [
      'tw-absolute',
      'tw-inset-0',
      'tw-flex',
      'tw-justify-center',
      'tw-items-center',
      'tw-z-50',
      'tw-bg-opacity-50'
    ]
    if (appearance === 'dark') {
      classNames.push('tw-bg-black')
    }
    else {
      classNames.push('tw-bg-gray-200')
    }
    return classNames
  }, [appearance])

  return (
    <div
      className={classNames.join(' ')} >
      <LoadingIcon size="4xl"/>
    </div>
  )
}


export default ScreenLoader
